import styled from 'styled-components';
import { useTranslation } from 'next-i18next';
import {
  OfferCardBadgeProps,
  OfferCardProps
} from '../../../entity/components/OfferCardsContainer';
import WhatsappButton from './entity-cards/WhatsappButton';
import Image from 'next/image';

const OfferCardBadge = ({ offerName }: OfferCardBadgeProps): JSX.Element => {
  return (
    <OfferBadge>
      <p>{offerName}</p>
    </OfferBadge>
  );
};

const OfferCardMobile = ({
  offer,
  entity,
  paymentDetails,
  originalPaymentPlan
}: OfferCardProps): JSX.Element => {
  const { t } = useTranslation(['entity', 'common']);

  return (
    <CardContainer>
      <div className="card-body">
        <div className="payment-plan">
          <p className="payment-percentage">
            {paymentDetails.payment_percentage}
          </p>
          <p className="payment-type">{paymentDetails.payment_type}</p>
          <p className="payment-duration">{paymentDetails.payment_duration}</p>

          {offer.discount ? (
            <div className="discount-original-plan">
              {' '}
              {t('valid_on')}{' '}
              {`${originalPaymentPlan?.down_payment.percent}% ${t(
                'downpayment'
              )}, ${originalPaymentPlan?.years} ${t('years')}`}
            </div>
          ) : (
            originalPaymentPlan?.down_payment?.percent > 0 &&
            originalPaymentPlan?.years > 0 && (
              <div className="original-payment-plan">
                {`${originalPaymentPlan?.down_payment.percent}% ${t(
                  'downpayment'
                )}, ${originalPaymentPlan.years} ${t('years')}`}
              </div>
            )
          )}
        </div>

        <div className="card-actions">
          <p className="compound">{offer.compound.name}</p>
          {(offer.offer?.installment_type?.name === 'Back Loaded' ||
            offer.original_payment_plan?.installment_type?.name ===
              'Back Loaded') && (
            <div className="plan-type">
              <div className="escalating-icon">
                <Image
                  width={18}
                  height={18}
                  alt="Offer Tag"
                  src={`/assets/icons/common/escalating-payment.svg`}
                />
              </div>
              {t('escalating_payments', { ns: 'common' })}
            </div>
          )}

          <div>
            <div className="get-offer-btn">{t('get_offer')}</div>

            <WhatsappButton entity={entity} offer={offer} />
          </div>
        </div>
      </div>
    </CardContainer>
  );
};

const OfferBadge = styled.div`
  position: absolute;
  top: 0;
  inset-inline-end: 0;
  background-color: #ff9108;
  min-width: 100%;
  max-width: 118px;
  height: 22px;
  font-size: 12px;
  color: white;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px 5px 2px 5px;
  border: 1px solid transparent;
  border-start-end-radius: 8px;
  border-start-start-radius: 8px;
  overflow: hidden;
`;

const CardContainer = styled.div`
  width: 230px;
  height: 290px;
  max-height: 290px;
  position: relative;
  background-color: #f0f1f3;
  border: 1px solid #e6e6e6;
  border-radius: 8px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;

  .card-body {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    .payment-plan {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      text-align: center;

      .payment-percentage {
        color: #ff9108;
        font-size: 34px;
        font-family: materialBold;
        margin-bottom: 5px;
      }

      .payment-type {
        font-size: 12px;
        font-family: materialRegular;
        color: #646464;
        margin-bottom: 10px;
      }

      .payment-duration {
        color: #666666;
        font-size: 18px;
        font-family: materialBold;
      }
    }

    .discount-original-plan {
      font-size: 12px;
      color: #666;
      font-family: materialRegular;
    }

    .original-payment-plan {
      font-size: 12px;
      color: #666;
      font-family: materialRegular;
      text-decoration: line-through;
    }

    .card-actions {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      text-align: center;

      .plan-type {
        font-family: materialMedium;
        font-size: 11px;
        color: #3e4042;
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 10px;
        align-self: center;
        .escalating-icon {
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 4px;
          background: #edf1f6;
          padding: 4px;
        }
      }

      .compound {
        color: #212427;
        font-size: 16px;
        font-family: materialBold;
        margin-bottom: 10px;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      .get-offer-btn {
        width: 100%;
        height: 27px;
        margin-bottom: 5px;
        background-color: #eb9e48;
        border: 1px dashed #ffffff;
        padding: 0px 8px 0px 8px;
        color: #ffffff;
        font-size: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: materialBold;
      }
    }
  }
`;

export default OfferCardMobile;
